module.exports = __webpack_public_path__ + "img/skeleton-structure.96f66f5e.jpg";